import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { get, post, patch, deleteFun } from "./request/http";
import "./global.less";

Vue.config.productionTip = false;

Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$patch = patch;
Vue.prototype.$delete = deleteFun;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
